module.exports = __webpack_public_path__ + "components/outside-promo-page/static/mountain-forecast__icon-76a84d9c1653095ca4458cac15e42777.svg";